import React from 'react';
import LogoInstitutionals from 'src/components/LandingPage/LogoInstitutionals';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

const FinancingSectionRedesign = () => {
  return (
    <section
      css={{
        padding: '5rem 2rem',
        backgroundColor: colors.white,
        [mediaQueries.phoneOnly]: {
          padding: '3rem 1rem',
        },
      }}
    >
      <div
        css={{
          maxWidth: 1200,
          margin: '0 auto',
        }}
      >
        <h2
          css={{
            textAlign: 'center',
            fontSize: '2.5rem',
            marginBottom: '1rem',
            color: colors.purpleDark,
            fontWeight: 700,
            [mediaQueries.phoneOnly]: {
              fontSize: '1.75rem',
            },
          }}
        >
          Le co&ucirc;t de la formation ne doit pas &ecirc;tre{' '}
          <span css={{ color: colors.purple }}>un frein</span>
        </h2>

        <p
          css={{
            textAlign: 'center',
            fontSize: '1.25rem',
            color: colors.darkGrey,
            marginBottom: '3rem',
            maxWidth: 750,
            marginLeft: 'auto',
            marginRight: 'auto',
            lineHeight: 1.7,
            [mediaQueries.phoneOnly]: {
              fontSize: '1rem',
              marginBottom: '2rem',
            },
          }}
        >
          De nombreux dispositifs existent pour financer votre reconversion. Nous
          vous accompagnons concr&egrave;tement, &eacute;tape par &eacute;tape.
        </p>

        <LogoInstitutionals />
      </div>
    </section>
  );
};

export default FinancingSectionRedesign;
